import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {
    httpRemoveProjectFromSiarExport,
    HttpRemoveProjectFromSiarExportPayload,
    HttpRemoveProjectFromSiarExportResponse
} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'

export const useRemoveProjectFromSiarExport = (
    options?: Omit<
        UseMutationOptions<HttpRemoveProjectFromSiarExportResponse, AxiosError, HttpRemoveProjectFromSiarExportPayload>,
        'mutationKey' | 'mutationFn'
    >
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.REMOVE_PROJECT_FROM_SIAR_EXPORT],
        mutationFn: payload => httpRemoveProjectFromSiarExport(payload),
        onSettled: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_HISTORY]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_EXPORT_DETAIL]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_PREVIEW]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_PREVIEW_COUNTERS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            options?.onSettled?.(...args)
        }
    })
